import { useTranslation } from 'react-i18next';

import clsx from 'clsx';

import { useResponsive } from '@/hooks/useResponsive';
import { PRODUCT_NAME } from '@/shared/constance';

import css from './index.module.less';

export function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const { isMobile } = useResponsive();

  return (
    <footer className={clsx(css['footer'], isMobile && css['mobile-footer'])}>
      <div className={clsx(css['footer-content'], isMobile && css['mobile-footer-content'])}>
        {/* Navigation Links */}
        <div className={clsx(css['nav-links'], isMobile && css['mobile-nav-links'])}>
          {/* 政策链接组 */}
          <div className={clsx(css['nav-group'], isMobile && css['mobile-nav-group'])}>
            <a
              href="/policies/terms-of-use"
              className={clsx(css['nav-link'], isMobile && css['mobile-nav-link'])}
              target="_blank"
            >
              <div className={clsx(css['nav-link-icon'])}></div>
              {t('footer.termsOfService')}
            </a>
            <a
              href="/policies/privacy-policy"
              className={clsx(css['nav-link'], isMobile && css['mobile-nav-link'])}
              target="_blank"
            >
              <div className={clsx(css['nav-link-icon'])}></div>
              {t('footer.privacyPolicy')}
            </a>
            <a
              href="/policies/cookie-policy"
              className={clsx(css['nav-link'], isMobile && css['mobile-nav-link'])}
              target="_blank"
            >
              <div className={clsx(css['nav-link-icon'])}></div>
              {t('footer.cookiePolicy')}
            </a>

            <a
              href="/docs"
              className={clsx(css['nav-link'], isMobile && css['mobile-nav-link'])}
              target="_blank"
            >
              <div className={clsx(css['nav-link-icon'])}></div>
              {t('footer.docs')}
            </a>
          </div>

          {!isMobile && <div className={clsx(css['divider'])}></div>}

          {/* 社交链接组 */}
          <div className={clsx(css['social-group'], isMobile && css['mobile-social-group'])}>
            <a
              href="https://x.com/CodeFlicker_ai"
              target="_blank"
              rel="noopener noreferrer"
              className={clsx(css['social-link'], isMobile && css['mobile-social-link'])}
            >
              <div className={clsx(css['twitter-icon'])}></div>
              {t('footer.twitter')}
            </a>
            <a
              href="https://discord.gg/rVdpZS9D3C"
              target="_blank"
              rel="noopener noreferrer"
              className={clsx(css['social-link'], isMobile && css['mobile-social-link'])}
            >
              <div className={clsx(css['discord-icon'])}></div>
              {t('footer.discord')}
            </a>
          </div>
        </div>

        {/* Copyright and Font Notice */}
        <div className={clsx(css['footer-info'])}>
          <div className={clsx(css['copyright'])}>
            {t('footer.copyright', { year, productName: PRODUCT_NAME })}
          </div>
        </div>
      </div>
    </footer>
  );
}
